import { render } from "./OperatorDisplayBox.vue?vue&type=template&id=90c4fd9e"
import script from "./OperatorDisplayBox.vue?vue&type=script&lang=ts"
export * from "./OperatorDisplayBox.vue?vue&type=script&lang=ts"

import "./OperatorDisplayBox.vue?vue&type=style&index=0&id=90c4fd9e&lang=scss"
script.render = render

export default script